import React from 'react';
import {useT} from 'react-polyglot-hooks';
import ConfirmModal from '../ConfirmModal';

const ConfirmDelete = (props: {
  onClose: () => void,
  onDeleteClick: () => void,
  open: boolean
}) => {
  const {open, onClose, onDeleteClick} = props;
  const t = useT();

  return (
      <ConfirmModal
          onClose={onClose}
          onConfirmClick={onDeleteClick}
          open={open}
          title={String(t('Delete'))}
          message={String(t('Are you sure you want to delete this item? This action cannot be undone.'))}
          submitIsDelete
      />
  );
};

export default ConfirmDelete;
